import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSangre/updateControlSangre`, method: 'POST', body: values, token: token})
}
